import React from 'react';
import { ArrowUpRight, Check } from 'lucide-react';
import {
  BOOKING_GOLD,
  BOOKING_GOLD_RGBA,
  getPackageUpgradeOptions,
} from '../../constants/booking';

const sectionTitleStyle = {
  fontSize: '1.25rem',
  fontWeight: '600',
  marginBottom: '1rem',
  color: '#F5F0E8',
};

export default function AddOnSelector({
  selectedPackage,
  includedAddOns,
  onUpgradePackage,
}) {
  if (!selectedPackage) return null;

  const upgradeOptions = getPackageUpgradeOptions(selectedPackage);
  if (includedAddOns.length === 0 && upgradeOptions.length === 0) return null;

  const includedRowStyle = {
    border: `1px solid ${BOOKING_GOLD_RGBA}, 0.35)`,
    borderRadius: '0.75rem',
    padding: '1rem',
    backgroundColor: `${BOOKING_GOLD_RGBA}, 0.06)`,
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
  };

  return (
    <div style={{ marginBottom: '1.5rem' }}>
      {includedAddOns.length > 0 && (
        <>
          <h3 style={sectionTitleStyle}>Included with your package</h3>
          <div style={{ display: 'grid', gap: '0.75rem' }}>
            {includedAddOns.map((addon) => (
              <div key={addon.id} style={includedRowStyle}>
                <Check size={20} style={{ color: BOOKING_GOLD, flexShrink: 0 }} />
                <div style={{ flex: 1 }}>
                  <span style={{ fontWeight: '600', color: '#F5F0E8', display: 'block' }}>{addon.name}</span>
                  {addon.description && (
                    <span style={{ fontSize: '0.8125rem', color: 'rgba(245, 240, 232, 0.65)', display: 'block', marginTop: '0.25rem', lineHeight: 1.4 }}>
                      {addon.description}
                    </span>
                  )}
                </div>
                <span style={{ fontWeight: '700', color: BOOKING_GOLD, flexShrink: 0, fontSize: '0.8125rem' }}>
                  Included
                </span>
              </div>
            ))}
          </div>
        </>
      )}

      {upgradeOptions.length > 0 && (
        <div style={{ marginTop: includedAddOns.length > 0 ? '1.25rem' : 0 }}>
          <p
            style={{
              fontSize: '0.8125rem',
              fontWeight: 600,
              letterSpacing: '0.04em',
              textTransform: 'uppercase',
              color: 'rgba(245, 240, 232, 0.55)',
              margin: '0 0 0.75rem',
            }}
          >
            Looking for more?
          </p>
          <div style={{ display: 'grid', gap: '0.625rem' }}>
            {upgradeOptions.map((option) => (
              <button
                key={option.targetPackageId}
                type="button"
                onClick={() => onUpgradePackage?.(option.targetPackageId)}
                style={{
                  width: '100%',
                  textAlign: 'left',
                  border: `1px solid ${BOOKING_GOLD_RGBA}, 0.4)`,
                  borderRadius: '0.75rem',
                  padding: '0.875rem 1rem',
                  backgroundColor: 'transparent',
                  color: '#F5F0E8',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  fontSize: '0.875rem',
                  lineHeight: 1.45,
                  fontWeight: 500,
                }}
              >
                <ArrowUpRight
                  size={18}
                  style={{ color: BOOKING_GOLD, flexShrink: 0 }}
                />
                <span style={{ flex: 1 }}>{option.label}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
